var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@font-face{font-family:UnidreamLED;src:url(" + escape(require("./led.ttf")) + ")}.numberfont{font-family:UnidreamLED!important;font-size:80px}", "", {"version":3,"sources":["G:/new-git/zsbs/src/assets/icons/G:/new-git/zsbs/src/assets/icons/numberfont.css"],"names":[],"mappings":"AAAA,WAAY,wBAA2B,AACnC,iCAAoB,CACvB,AAED,YACI,kCAAqC,AACrC,cAAe,CAIlB","file":"numberfont.css","sourcesContent":["@font-face {font-family: \"UnidreamLED\";\r\n    src: url('led.ttf'); /* IE9*/\r\n}\r\n\r\n.numberfont {\r\n    font-family:\"UnidreamLED\" !important;\r\n    font-size:80px;\r\n    /*font-style:normal;*/\r\n    /*-webkit-font-smoothing: antialiased;*/\r\n    /*-moz-osx-font-smoothing: grayscale;*/\r\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/icons/numberfont.css
// module id = zv9C
// module chunks = 1